import keys from '@debbie/common/dist/cache/keys.js';
import { DKTribunalJobType } from '@debbie/common/dist/tribunal/jobs/countries/denmark.js';
import * as files from '@debbie/cortex/dist/api/files.js';
import * as tribunalAPI from '@debbie/cortex/dist/api/tribunal.js';
import { caseVouchersEntity } from '@debbie/cortex/dist/case-vouchers/index.js';
import { useCase } from '@debbie/cortex/dist/cases/index.js';
import { h } from '@debbie/cortex/dist/index.js';
import q from '@debbie/cortex/dist/query.js';
import { tribunalJobsEntity } from '@debbie/cortex/dist/tribunal/index.js';
import { ensureUpdatesLoadedByRef, updatesEntity, } from '@debbie/cortex/dist/updates/index.js';
import moment from 'moment';
import React, { useRef, useState } from 'react';
import Dropzone from 'react-dropzone';
import { useSelector } from 'react-redux';
import { Button, DateInput, File, Input } from '../../../index.js';
import MoneyInput from '../../../MoneyInput.js';
const Register1Paategning = (props) => {
    const lang = useSelector((s) => s.lang);
    const singleCaseLoader = useCase(props.tribunalCase.caseId);
    const singleCase = h.hasData(singleCaseLoader) ? singleCaseLoader.data : null;
    const [loading, setLoading] = useState(false);
    const [fsNo, setFsNo] = useState('FS');
    const [costs, setCosts] = useState(null);
    const [date, setDate] = useState(moment());
    const [file, setFile] = useState(null);
    const dropzoneRef = useRef(null);
    const promiseFileReader = async (file) => {
        return new Promise((resolve, reject) => {
            const reader = new FileReader();
            reader.onload = async (event) => {
                resolve(event.target.result);
            };
            reader.onerror = reject;
            reader.readAsDataURL(file);
        });
    };
    const uploadFile = async (acceptedFiles) => {
        for (let i = 0; i < acceptedFiles.length; i++) {
            const acceptedFile = acceptedFiles[i];
            const content = await promiseFileReader(acceptedFile);
            const { file } = await files.save({
                content: content.split('base64,')[1],
                name: acceptedFile.name,
                contentType: acceptedFile.type,
            });
            setFile(file);
        }
    };
    const register1Paategning = async () => {
        setLoading(true);
        try {
            if (!costs) {
                throw new Error('Cost amount are required');
            }
            if (!date) {
                throw new Error('Date is required');
            }
            await tribunalAPI.createTribunalJob({
                type: DKTribunalJobType.Register1Paategning,
                tribunalCaseId: props.tribunalCase.id,
                data: {
                    fileId: file?.fileId,
                    costs,
                    date: date.format(),
                },
                caseId: props.tribunalCase.caseId,
                reference: fsNo.trim(),
            });
            if (singleCase) {
                q.invalidate([...keys.write.create(updatesEntity)]);
                q.invalidate([...keys.write.create(caseVouchersEntity)]);
                await ensureUpdatesLoadedByRef(singleCase.caseId);
            }
            props.onSubmit();
        }
        catch (err) {
            console.error(err);
        }
        setLoading(false);
        q.invalidate(keys.write.create(tribunalJobsEntity));
    };
    return (React.createElement(Dropzone, { style: {}, disableClick: true, ref: dropzoneRef, multiple: true, onDrop: uploadFile },
        React.createElement("h4", null, lang.tribunal.register1Paategning),
        !props.tribunalCase.reference && (React.createElement(Input, { placeholder: lang.tribunal.fsNo, value: fsNo, onChange: (e) => setFsNo(e.target.value) })),
        React.createElement(MoneyInput, { placeholder: lang.tribunal.courtCaseCosts, value: costs, onChange: (e) => setCosts(e), allowNull: true }),
        React.createElement(DateInput, { allowNull: true, placeholder: lang.tribunal.foerstePaategningDate, value: date, onChange: (d) => setDate(d) }),
        React.createElement(Button, { onClick: () => {
                // @ts-ignore
                dropzoneRef.current?.open();
            }, size: "small", theme: "secondary", block: true }, lang.tribunal.addDocument),
        file && (React.createElement("p", null,
            React.createElement(File, { file: file, removable: true, onRemove: () => setFile(null) }))),
        React.createElement("br", null),
        React.createElement(Button, { onClick: register1Paategning, loading: loading, block: true, disabled: !(costs && date && (props.tribunalCase.reference || fsNo)) }, lang.tribunal.register1Paategning)));
};
export default Register1Paategning;
//# sourceMappingURL=Register1Paategning.js.map